import React, { useState, useEffect } from "react";
import "../Admin/css/login.css";
import { useNavigate } from "react-router-dom";
import { secureStorage } from "../utils/secureStorage.js";
import { loginUser } from "../service/authService.js";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { getCompanyUrl } from "../utils/getCompanyUrl.js";
//import logos from "../Admin/logo/mathangi_logo.png";
const Admin = () => {
  const [scholarId, setScholarId] = useState("");       
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();  
     //e.stopPropagation(); 
     if (loading) return;
    setLoading(true);
    setError("");

    try {
      const res = await loginUser({     
        user_id: scholarId,
        pwd: password,
      //com_url_code:"http://maathangischolar.seasense.in/",
      com_url_code: getCompanyUrl(),  
      });           

        // If backend returns success = false
    if (!res.data.token) {
      setError(res.data.message || "Invalid User ID or Password");
      return;
    }

      const { token, user, scholar, company_details, last_work_details } = res.data;

      secureStorage.setToken(token);
      secureStorage.setuser(user);
      secureStorage.setScholar(scholar);
      secureStorage.setCompany(company_details);
      secureStorage.setWork(last_work_details);

       navigate("/dashboard");
  } catch (err) {
    setError(
      err?.response?.data?.message ||  "Invalid User ID or Password"
      //err?.message ||
     
    );
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  const token = secureStorage.getToken();

  if (token) {
    const lastRoute = localStorage.getItem("lastRoute");

    navigate(lastRoute || "/dashboard", {
      replace: true,
    });
  }
}, [navigate]);

  return (
    <div className="login-wrapper">
        

      {/* LEFT SIDE */}
      {/* <div className="login-left">
        <div className="overlay">
          
        </div>
      </div> */}
    
      <div className="login-right">
       
        <div className="login-box">
          
          <h2>Welcome Back!</h2>
          <p className="sub-text">Login to your account</p>

          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="User ID"
              value={scholarId}
              onChange={(e) => { setScholarId(e.target.value); setError(""); }}
              required
            />
 <div className="password-input-box">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError(""); }}
              required
            />
            <span
                className="password-eye"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? < FaEye/> : < FaEyeSlash/>}
              </span>
</div>
            <button type="submit" disabled={loading}>
              {loading ? "Logging in..." : "Login Now"}
            </button>
          </form>
          {error && <p className="error-message">{error}</p>}
          <div className="extra">
            <span 
    style={{ cursor: "pointer", color: "#fff" }}
    onClick={() => navigate("/forgotpassword")}
  >
    Forgot password?
  </span>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Admin;